/**
 * Compute a stable device fingerprint using FingerprintJS.
 * The fingerprint persists across cookie clears and incognito sessions,
 * letting us track true unique visitors vs session-based tokens.
 *
 * Caches the result in memory so we compute it once per page load.
 */

import FingerprintJS from '@fingerprintjs/fingerprintjs'

let cachedFingerprint: string | null = null

/**
 * Get the device fingerprint. Returns a promise that resolves to a stable
 * hash. Safe to call multiple times — internally memoized.
 */
export async function getFingerprint(): Promise<string> {
  if (cachedFingerprint) return cachedFingerprint

  try {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    cachedFingerprint = result.visitorId
    return cachedFingerprint
  } catch (error) {
    console.warn('[fingerprint] Failed to compute fingerprint:', error)
    // Empty string on failure so tracking still works (token-only).
    return ''
  }
}
